import { Languages } from "lucide-react";

const LANGS = [
    { code: "en", name: "English" },
    { code: "es", name: "Español" },
    { code: "zh", name: "中文" },
    { code: "hi", name: "हिन्दी" },
    { code: "ar", name: "العربية" },
    { code: "fr", name: "Français" },
    { code: "pt", name: "Português" },
];

export default function LangSwitcher({ value, onChange, pending = false, dataTestid = "lang-switcher" }) {
    return (
        <div
            className="border-2 border-white/20 p-3 flex items-center gap-3 flex-wrap"
            data-testid={dataTestid}
        >
            <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-white/60">
                <Languages size={12} /> LANGUAGE
            </div>
            <div className="flex flex-wrap gap-2">
                {LANGS.map((l) => {
                    const active = value === l.code;
                    return (
                        <button
                            key={l.code}
                            onClick={() => onChange(l.code)}
                            data-testid={`lang-${l.code}`}
                            className={`font-mono text-[10px] uppercase tracking-wider px-2 py-1 border-2 transition-colors ${
                                active
                                    ? "bg-white text-black border-white"
                                    : "border-white/20 text-white/70 hover:border-white"
                            }`}
                            dir={l.code === "ar" ? "rtl" : "ltr"}
                        >
                            {l.name}
                        </button>
                    );
                })}
            </div>
            {pending && (
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FFCC00] ml-auto">
                    TRANSLATION PENDING — REFRESH IN ~30s
                </span>
            )}
        </div>
    );
}
